<template>
  <div v-if="show">
    <vxe-modal v-model="show" :title="name" width="700" min-width="700" height="550" min-height="550" showFooter
      esc-closable mask-closable resize>
      <template v-slot>
        <el-form ref="form" size="small" :model="data" label-width="auto" label-position="right" :rules="rules">
          <el-form-item label="供应商">
            {{data.supplierName}}
          </el-form-item>
          <el-form-item label="产品">
            {{data.productName}}
          </el-form-item>
          <el-form-item label="车数">
            {{data.carNum}}
          </el-form-item>
          <el-form-item prop="typeId" label="产品类型">
            <el-select v-model="data.typeId" placeholder="选择产品类型" size="mini" :disabled="!isAdd"
                       style="width: 100%;" @change="changeType()">
              <el-option v-for="(item, index) in productType" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <template v-for="(item,index) in assayProduct">
            <el-form-item :prop="item.name" :label="item.label" :key="index">
              <el-input v-model="data[item.name]" :placeholder="item.placeholder" type="number"></el-input>
            </el-form-item>
          </template>
        </el-form>
      </template>
      <template v-slot:footer>
        <div style="text-align: center">
          <vxe-button status="primary" style="width: 100%" @click="save" v-loading="loading">确定</vxe-button>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      name: '',
      data: {},
      ids: [],
      rules: {},
      loading: false,
      assayProduct: [],
      productType: [],
      isAdd: false,
    }
  },
  methods: {
    /** 打开界面方法 */
    display(data) {
      this.show = true
      this.data = this.$utils.clone(data.data, true)
      this.isAdd = data.isAdd
      this.name = data.name
      this.productType = data.productType
      this.assayProduct = this.$utils.sortBy(data.assayProduct, [['sort', 'asc']])
      this.getRules()
    },
    getRules() {
      this.rules = {typeId: [{required: true, trigger: 'change', message: '请选择产品类型'}]}
      let typeName
      this.productType.forEach(item => {
        if (item.id === this.data.typeId) typeName = item.name
      })
      this.assayProduct.forEach(item => {
        item['placeholder'] = `输入${item.label}`
        if (!['g', 'shimo', 'x', 'y'].includes(item.name) && typeName !== '样品') {
          this.$set(this.rules, item.name, [{required: true, trigger: 'blur', message: item['placeholder']}])
        } else if (typeName === '样品') {
          this.$set(this.rules, item.name, [{required: false, trigger: 'blur', message: item['placeholder']}])
        }
      })
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    },
    changeType() {
      this.$axios.get(`/order/assay/item/type/${this.data.typeId}`).then(response => {
        if (response){
          this.assayProduct = this.$utils.sortBy(response.data.data, [['sort', 'asc']])
          this.getRules()
        }
      })
    },
    /** 保存方法 */
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          let assayNameList = []
          this.assayProduct.forEach(item => {
            assayNameList.push(item.name)
          })
          const assayParams = this.$utils.pick(this.data, assayNameList)
          let params
          let url
          if (this.isAdd) {
            url = '/order/assay/create/hand'
            params = {
              assayId: this.data.id,
              typeId: this.data.typeId,
              params: assayParams
            }
          } else {
            url = '/order/assay/update'
            params = {
              id: this.data.id,
              params: assayParams
            }
          }
          this.$axios
            .post(url, params)
            .then((res) => {
              if (res) {
                if (this.isAdd) {
                  this.$message.success('新增成功')
                } else {
                  this.$message.success('修改成功')
                }
                this.show = false
                this.$emit('init')
              }
              this.loading = false
            })
            .catch((err) => {
              console.log('修改化验单失败', err)
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
  },
}
</script>
